export default __webpack_public_path__ + "static/media/right flower.ffa31c4d.png";